import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// Redux
import { connect, useDispatch, useSelector} from "react-redux";

import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from "@fullcalendar/list";
import BootstrapTheme from "@fullcalendar/bootstrap";


import { withRouter} from "react-router-dom";

import SweetAlert from "react-bootstrap-sweetalert";
import {
   
    Card,
    CardBody,
    Col,
    Container,
   
    Row,
  } from "reactstrap";

import {agendaFulllist, agendaDelete, agendaCreate, agendaFilter, agendaUpdate} from '../../store/agenda/actions'
import { contactsFulllist } from "../../store/contacts/actions";
import { userFullList } from "../../store/admin/user/actions"
import { casosFullList } from "../../store/casos/actions";
import { grupotecnicoFullList } from "../../store/grupoTecnico/actions";

import DeleteModal from "./DeleteModal";
import CrearEditModal from "./CrearEditModal";




const Calendario = (props) => {

  const dispatch= useDispatch();


  useEffect(() => {
    
    dispatch(agendaFulllist())
    dispatch(contactsFulllist())
    dispatch(userFullList())
    dispatch(casosFullList())
    dispatch(grupotecnicoFullList())
  },[dispatch])
 
 
  
    const [modal, setModal] = useState(false);
    
    const [deleteModal, setDeleteModal] = useState(false);
  
    const [event, setEvent] = useState({});
    const [selectedDay, setSelectedDay] = useState(0);
    const [isEdit, setIsEdit] = useState(false);

    const [currentEvents, setCurrentEvents] = useState([]);

    console.log(currentEvents)
    const [crearModal, setCrearModal] = useState(false)
    const agenda = useSelector(state => state.Agenda.agenda) || []
    
    const contact = useSelector(state => state.Contacts.contacts) || []
    console.log(contact)

    console.log(modal,setModal)
    

  
    const categories = [
        {id: 1, title: 'New Event Planning', type: 'bg-success'},
       
        {id: 2, title: 'Meeting', type: 'bg-info'},
       
        {id: 3, title: 'Generating Reports', type: 'bg-warning'},
       
        {id: 4, title: 'Create New theme', type: 'bg-danger'},
    ]

   console.log(categories)

    const [formData, setFormData] = useState({
      contacto:[],
      casos:"",
      grupo_tecnico:"",
     
     
      
    });
    
    const {
      contacto,
      casos,
      grupo_tecnico,
      
    } = formData;

   
 
  
    
    const onChange = (e) => {
    
      setFormData({ ...formData, [e.target.name]: e.target.value });
      }


      

    const handleDateClick = (selected) => {
        
      
    
        
      //  setModal(true)
        setCrearModal(true)
        setSelectedDay(selected)
       
        setIsEdit(false);
        
        
        
      };

      

  
     

             /**
   * Handling submit event on event form
   */
             
            
  const handleValidEventSubmit = (e, values) => {
    
  
    if (isEdit) {
     
      // update event
      
      dispatch(agendaUpdate(agenda.id,{
        title:values.title,
        start: agenda.start,
        end:agenda.end,
        contacto:contacto,
        caso:casos,
        grupo_tecnico:grupo_tecnico

      }))
    } else {

      const   start  = selectedDay.dateStr
      const startRecortado = start.toString().slice(0,19)
      const   end  = selectedDay.dateStr
      const endRecortado = end.toString().slice(0,19)
      const newEvent = {
        
        title: values["title"],
        start: selectedDay ? (selectedDay.startStr?selectedDay.startStr:  startRecortado) : new Date(),
        end: selectedDay ? (selectedDay.endStr?selectedDay.endStr:  endRecortado) : new Date(),
        contacto: contacto,
        className: values.category + " text-white",
        allDay: selectedDay.allDay,
        caso:casos,
        grupo_tecnico:grupo_tecnico
        
        


      };
      // save new event
    
      
      dispatch(agendaCreate(newEvent))
    }
    setSelectedDay(null);

    //Cierra el modal de create 
    handleCloseModal()

  };


        /**
   * Handling click on event on calendar
   */
        
 
       
  const handleEventClick = arg => {
    const event = arg.event;
    dispatch(agendaFilter(`${event.id}/`))
    
    setEvent({
      id: event.id,
      allday: event.allday,
      end:event.end,
      title: event.title,
      
      start: event.start,
      className: event.classNames,
     
    });
    
    setIsEdit(true);
    setCrearModal(true)
    setEvent({})
  };



  
    

    

    /**
   * On delete event
   */
    const handleDeleteEvent = () => {
      
      setDeleteModal(true)
     
      dispatch(agendaDelete(agenda.id));
      setDeleteModal(false);
      handleCloseModal()
    };



    const handleCloseModal = () => {
      setCrearModal(false);
      dispatch(agendaFulllist())
      dispatch(casosFullList())
    };

       /**
   * On calendar drop event si se arrastra
   */
       const onDrop = event => {
        const caso = event.event._def.extendedProps.caso
 

        console.log(event.event)
       const   start  = event.event.startStr
       const startRecortado = start.toString().slice(0,19)
       const   end  = event.event.endStr
       const endRecortado = end.toString().slice(0,19)
       const allDay = event.event.allDay
      
      dispatch(agendaUpdate(event.event.id,{
        
        start: startRecortado,
        end:endRecortado,
        allDay:allDay,
        caso:caso
        

      }))
       
       
       
      };

      // Manejar si el evento aumenta o dismuye

      const handleResize = event => {
        
        const caso = event.event._def.extendedProps.caso
 

        console.log(caso)
        const   start  = event.event.startStr
        const startRecortado = start.toString().slice(0,19)
        const   end  = event.event.endStr
        const endRecortado = end.toString().slice(0,19)
        const allDay = event.event.allDay
       
       dispatch(agendaUpdate(event.event.id,{
         
         start: startRecortado,
         end:endRecortado,
         allDay:allDay,
         caso:caso
        }))
       
       
       
      };
    

    return ( 
    
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteEvent}
        onCloseClick={() => setDeleteModal(false)}
      />

      { crearModal? (
        <CrearEditModal
        crearModal={crearModal}
        onCloseClick={handleCloseModal}
        handleValidEventSubmit={handleValidEventSubmit}
        isEdit={isEdit}
        event={event}
        handleDeleteEvent={handleDeleteEvent}
        handleEventClick={handleEventClick}
        agenda={agenda}
        onChange={onChange}
        grupo_tecnico={grupo_tecnico}
        setFormData={setFormData}
        formData={formData}
       
 
        >
      </CrearEditModal>
      ):null} 
      

      


                  {props.agendaDeleted  ? (
                                    <SweetAlert
                                      title="Hecho!"
                                      success
                                      timeout={1000}
                                      showConfirm={false}
                                      onConfirm={() => {
                                        dispatch(agendaFulllist());
                                        dispatch(casosFullList())
                                      }}
                                    >
                                      Se ha borrado el Evento Correctamente
                                    </SweetAlert>
                                  ) : null}
                  {props.agendaCreated.id  ? (
                                    <SweetAlert
                                      title="Hecho!"
                                      success
                                      timeout={1000}
                                      showConfirm={false}
                                      onConfirm={() => {
                                        dispatch(agendaFulllist());
                                        dispatch(casosFullList())
                                      }}
                                    >
                                      Se ha creado el evento
                                    </SweetAlert>
                                  ) : null}

                                {props.agendaUpdated.id  ? (
                                    <SweetAlert
                                      title="Hecho!"
                                      success
                                      timeout={1000}
                                      showConfirm={false}
                                      onConfirm={() => {
                                        dispatch(agendaFulllist());
                                        dispatch(casosFullList())
                                      }}
                                    >
                                      Se ha actualizado el evento
                                    </SweetAlert>
                                  ) : null}


         <div className="page-content">
                <Container fluid={true}>
                        {/* Render Breadcrumb */}
                    
                        <Row>
                            <Col className="col-12">
                            <Row>

                   

                            {/* Calendario */}

                            <Col className="col-lg-12
                            ">
                                <Card>
                                    <CardBody>
                                    <FullCalendar
                                                plugins={[
                                                
                                                dayGridPlugin,
                                                timeGridPlugin,
                                                interactionPlugin,
                                                listPlugin,
                                                BootstrapTheme
                                                ]}
                                                
                                                
                                                
                                                headerToolbar={{
                                                left: "prev,next today",
                                                center: "title",
                                                right: "timeGridWeek,timeGridDay",
                                                }}
                                                businessHours={ {
                                                  start: '10:00', // hora final
                                                  end: '18:00', // hora inicial
                                                  dow: [ 1, 2, 3, 4, 5 ] // dias de semana, 0=Domingo
                                                }}
                                                initialView="timeGridWeek"
                                                editable={true}
                                                selectable={true}
                                               
                                                dayMaxEvents={true}
                                                select={handleDateClick}
                                                eventClick={handleEventClick}
                                                dateClick={handleDateClick}
                                                eventResize={handleResize}
                                                eventsSet={(events) => setCurrentEvents(events)}
                                                eventDrop={onDrop}
                                                events={agenda}
                                                allDay={true}
                                                
                                            />




                          


                    
                                    </CardBody>
                                </Card>
                            </Col>
                          
                            </Row>
                            </Col>
                        </Row>
                </Container>
        </div>

        
    </React.Fragment>
  
    );
}
 
const mapStateToProps = (state) => {
  const { error, loading, agenda, agendaDeleted, agendaCreated, agendaUpdated} = state.Agenda;
  return { error, loading, agenda, agendaDeleted , agendaCreated, agendaUpdated};
};


Calendario.propTypes = {
    error: PropTypes.any,
    loading: PropTypes.bool,
    
    agendaDeleted: PropTypes.object,
    agendaCreated: PropTypes.object,
    agendaUpdated: PropTypes.object,

    };
export default withRouter(connect(mapStateToProps , { agendaFulllist, agendaDelete, agendaCreate, agendaUpdate}) (Calendario));